function getBackgroundColor(args) {
    const {row: row, table: table} = args;
    return 1 & row - table.frozenRowCount ? "#FFF" : "#F4F8FF";
}

export default {
    name: "BRIGHT",
    underlayBackgroundColor: "#FFF",
    defaultStyle: {
        color: "#FFF",
        bgColor: "#5389FF",
        borderColor: "#5286FA",
        hover: {
            cellBgColor: "#2E67E3"
        }
    },
    headerStyle: {
        color: "#FFF",
        bgColor: "#5389FF",
        borderColor: "#A1C1FF",
        hover: {
            cellBgColor: "#2E67E3"
        }
    },
    bodyStyle: {
        color: "#000",
        bgColor: getBackgroundColor,
        borderColor: "#E0EAFE",
        hover: {
            cellBgColor: "#E9EFFD"
        }
    },
    frameStyle: {
        borderColor: "#E1E4E8",
        borderLineWidth: 1,
        borderLineDash: [],
        cornerRadius: 0,
        shadowBlur: 0,
        shadowOffsetX: 0,
        shadowOffsetY: 0,
        shadowColor: "black"
    },
    columnResize: {
        lineWidth: 1,
        lineColor: "#416EFF",
        bgColor: "#D9E2FF",
        width: 3
    },
    frozenColumnLine: {
        shadow: {
            width: 3,
            startColor: "#CBDCFE",
            endColor: "#CBDCFE",
            visible: "always"
        }
    },
    selectionStyle: {
        cellBgColor: "rgba(0, 0, 255,0.1)"
    },
    tooltipStyle: {
        bgColor: "#FFF",
        color: "#000",
        fontSize: 12,
        fontFamily: "Arial,sans-serif"
    }
};
//# sourceMappingURL=BRIGHT.js.map
